import { Build } from "@dashboard/products/types";

export function isBuildProcessing(build: Build): boolean {
    return build.buildStatus === "pending" || build.buildStatus === "running";
}
